import { ProductSerialnumber } from 'src/Libs/installations'
import { usePortalQuery } from 'src/Libs/api'
import { getProductSerialnumbers } from 'src/Libs/installations/api/device-link.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

/**
 * get the product serialnumbers for the given serialnumbers from the manufacturing db
 */
export const useProductSerialnumbers = (serialnumbers?: string[]): [ProductSerialnumber[], boolean, boolean] => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['product-serialnumbers', serialnumbers],
    queryFn: () => getProductSerialnumbers(serialnumbers ?? [], authFetch),
    enabled: !!serialnumbers?.length,
  })

  return [data ?? [], isLoading, isError]
}
